import { MouseEventHandler } from "react";

type KProps = Partial<{
  hideAfter: number;
  heading: string;
  type: string;
  role: string;
  toastContainerID: string;
  renderIcon: Function;
  bar: Partial<{
    size: string;
    style: "solid" | "dashed" | "dotted";
    color: string;
  }>;
  onClick: MouseEventHandler;
  onHide: Function;
}>;

type CTMethod = (message: string, options?: KProps) => void;

const showNotificationBar: CTMethod = (message, options) => {
  let notificationBar = document.querySelector(".notification-bar");

  if (!notificationBar) {
    notificationBar = document.createElement("div");
    notificationBar.className = "notification-bar";
    const messageElement = document.createElement("p");
    notificationBar.appendChild(messageElement);
    document.body.appendChild(notificationBar);
  }

  const p = notificationBar.getElementsByTagName("p");
  if (p.length === 0) {
    const messageElement = document.createElement("p");
    notificationBar.appendChild(messageElement);
  }

  const messageElement = notificationBar.getElementsByTagName("p")[0];
  messageElement.innerHTML = message;
  messageElement.classList.add(`text-${options?.type}`);

  notificationBar.classList.toggle("show");
  notificationBar.classList.add(`bg-${options?.type}`);

  setTimeout(() => {
    if (notificationBar) {
      notificationBar.classList.toggle("show");
      messageElement.classList.remove(`text-${options?.type}`);
      notificationBar.classList.remove(`bg-${options?.type}`);
    }
  }, (options?.hideAfter || 3) * 1000);
};

const ktoast = {
  success: (message: string, options?: KProps) => {
    showNotificationBar(message, { ...options, type: "success" });
  },
  warn: (message: string, options?: KProps) => {
    showNotificationBar(message, { ...options, type: "warning" });
  },
  error: (message: string, options?: KProps) => {
    showNotificationBar(message, { ...options, type: "danger" });
  },
  info: (message: string, options?: KProps) => {
    showNotificationBar(message, { ...options, type: "info" });
  },
};

export default ktoast;
